<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem>用户管理</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Button @click="handleCreate()" style="margin:0px 10px 20px" type="primary">新增</Button>
            <Table :columns="columns" :data="data"></Table>
            <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
            <Modal
                v-model="modal1"
                title="新建用户"
                width='300'
                @on-ok="ok"
                @on-cancel="cancel">
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <FormItem prop="username" style="margin-right: 0px; width: 100%">
                        <Input  v-model="formInline.username" placeholder="Username">
                            <Icon type="ios-person-outline" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                    <FormItem prop="email" style="margin-right: 0px; width: 100%">
                        <Input type="email" v-model="formInline.email" placeholder="Email">
                            <Icon type="ios-mail-outline" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                    <FormItem prop="password" style="margin-right: 0px; width: 100%">
                        <Input type="password" v-model="formInline.password" placeholder="Password">
                            <Icon type="ios-lock-outline" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                    <FormItem style="margin-right: 0px; width: 100%">
                        <Select v-model="formInline.role">
                            <Option v-for="item in roles" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </Modal>
        </Card>
    </div>
</template>
<script>
import{userList,deleteUser,roleList,changeRole,createUser}from "@/request/api"
import Cookies from 'js-cookie';
export default {
  name: 'userAdmin',
  meta:{},
  data() {
    return {
      formItem:{
          name: '',
          email: ''
      },
      columns: [
          {
              title: "名字",
              key: "name",
              align: "center"
          },
          {
              title: "邮箱",
              key: "email",
              align: "center"
          },
          {
              title: "企业微信id",
              key: "open_id",
              align: "center"
          },
          {
              title: "权限",
              key: "role_type",
              align: "center",
              render: (h, { row } ) => {
                  if (row.role_type === 1) {
                      return h('span', {
                      }, '管理员');
                  } else if (row.role_type === 2) {
                      return h('span', {
                      }, '普通用户');
                  } else if (row.role_type === 3) {
                      return h('span', {
                      }, '高级用户');
                  } else if (row.role_type === 0) {
                      return h('span', {
                      }, '禁止访问');
                  }
              },
          },
          {
              title: "登录时间",
              key: "login_at",
              align: "center"
          },
          {
              title: "操作",
              key: "action",
              align: "center",
              width: '200',
              render: (h, params) => {
                return h("div", [
                  h("Button", {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                            this.editRole(params.index)
                        },
                      },
                    },"编辑权限"),
                  h("Button",{
                      props: {
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: "提示",
                            content: "是否删除该项？",
                            onOk: () => {
                                this.remove(params.index)
                            },
                          });
                        },
                      },
                    },"删除"),
                ]);
              },
          },
      ],
      data:[],
      total_count:0,
      page:1,
      roles: [],
      formInline:{
          username: '',
          email: '',
          password: '',
          role: ''
      },
      ruleInline: {
          email: [
              { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
              { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
          ],
          password: [
              { required: true, message: 'Please fill in the password.', trigger: 'blur' },
              { type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'blur' }
          ]
      },
      modal1: false,
      role: ''
    };
  },
  methods: {
      getData(page=1,page_size=20,name,email){
          userList({page,page_size,name,email}).then(res=>{
              if(res.data.code==200){
                  this.data=res.data.data.items
                  // this.total_count=res.data.data.total
                  this.page = page
              }
          })
      },
      changePage(page){
          this.getData(page,20,this.formItem.name,this.formItem.email);
      },
      getRoleList(){
          roleList({}).then(res=>{
              if(res.data.code==200){
                  this.roles=res.data.data.items
              }
          })
      },
      handleCreate(){
          this.modal1 = true
      },
      ok(){
          createUser(
              {
                  username: this.formInline.username,
                  email: this.formInline.email,
                  password: this.formInline.password,
                  role_type: this.formInline.role
              }
          ).then(({ data: res }) => {
              if(res.code == 200){
                  this.getData(this.page,20,this.formItem.name,this.formItem.email)
              }
              this.$Message.info(res.msg);
              this.formInline = {
                  username: '',
                  email: '',
                  password: '',
                  role: ''
              }
          })
      },
      cancel(){
          this.modal1 = false,
          this.formInline = {
              username: '',
              email: '',
              password: '',
              role: ''
          }
      },
      editRole (index) {
          this.$Modal.confirm({
              new_email: '',
              new_password: '',
              closable: true,
              title: '编辑权限',
              width: 300,
              render: (h) => {
                  return h('Select', {
                      props:{
                          value: this.role,
                      },
                      on: {
                          'on-change':(value) => {
                              this.role = value
                          }
                      },
                  },
                  this.roles.map(function(type){
                      return h('Option', {
                              props: {value: type.value}
                          }, type.label);
                      })
                  );
              },
              onOk: () => {
                  changeRole(
                      {
                          email: this.data[index].email,
                          role_type: this.role
                      }
                  ).then(({ data: res }) => {
                      if(res.code == 200){
                          this.getData(this.page,20,this.formItem.name,this.formItem.email)
                      }
                      this.$Message.info(res.msg);
                      this.role = ''
                  })
              },
              onCancel: () => {
              }
          })
      },
      remove (index) {
          deleteUser(
              {
                  email: this.data[index].email
              }
          ).then(({ data: res }) => {
              if (res.code === 200){
                  this.getData(this.page,20,this.formItem.name,this.formItem.email)
              }
              this.$Message.info(res.msg);
          })
      },
  },
  created() {
      Cookies.set('active_name', '5');
      this.getData(1,20,this.formItem.name,this.formItem.email)
      this.getRoleList()
  },
};
</script>


// WEBPACK FOOTER //
// src/views/User/UserList.vue